import { useState } from "react";
import { MessageCircle, X, Sparkles } from "lucide-react";
import FeedbackModal from "./FeedbackModal";
import {
  wasPromptDismissed,
  markPromptDismissed,
  wasFeedbackSubmitted,
} from "../lib/feedback";

export default function FeedbackPrompt({ uploadId }) {
  const [dismissed, setDismissed] = useState(
    uploadId ? wasPromptDismissed(uploadId) || wasFeedbackSubmitted(uploadId) : false,
  );
  const [open, setOpen] = useState(false);

  if (dismissed) return null;

  return (
    <>
      <div
        className="mt-10 rounded-2xl border border-blue-200 bg-gradient-to-br from-blue-50 to-white p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4"
        data-testid="feedback-prompt"
      >
        <div className="h-11 w-11 rounded-xl bg-blue-600 text-white flex items-center justify-center shrink-0 shadow-sm shadow-blue-600/20">
          <Sparkles className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display font-semibold text-slate-900">
            How was this? Give quick feedback
          </h3>
          <p className="text-sm text-slate-600 mt-0.5">
            90 seconds — helps us make KnowYourPolicy.ai better for you and other drivers.
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0 self-start sm:self-center">
          <button
            type="button"
            onClick={() => setOpen(true)}
            data-testid="feedback-prompt-open"
            className="inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-4 py-2 text-sm font-semibold"
          >
            <MessageCircle className="h-4 w-4" />
            Give feedback
          </button>
          <button
            type="button"
            onClick={() => {
              if (uploadId) markPromptDismissed(uploadId);
              setDismissed(true);
            }}
            data-testid="feedback-prompt-dismiss"
            className="p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-white"
            aria-label="Dismiss feedback prompt"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>

      <FeedbackModal
        open={open}
        onClose={() => setOpen(false)}
        uploadId={uploadId}
      />
    </>
  );
}
